import React from 'react';
import Route from '../Route';
import GeckoStore from '../../services/gecko-store';

import Agents from './Agents.jsx';
import Invite from './Invite.jsx';
import Detail from './Detail.jsx';

const routes = new Route({
  path: '/agents',
  children: [
    {
      name: 'Agents',
      path: '/',
      action: async function (context) {
        return <Agents />;
      },
    },
    {
      name: 'Invite',
      path: '/invite',
      requires: ['admin', 'supervisor'],
      action: async function () {
        return <Invite />;
      },
    },
    {
      name: 'Agent',
      path: '/:agent_id',
      requires: [
        'admin',
        'supervisor',
        function (context) {
          const currentUser = GeckoStore.redux.get('appState.loggedInUser');
          if (Number(context.params.agent_id) === Number(currentUser.id)) {
            return 'agent';
          }
          return null;
        },
      ],
      action: ({ params }) => <Detail agent_id={Number(params.agent_id)} />,
    },
  ],
});

export default routes;
